import { calcImageUrl, getWidthByHeight } from '../../util';

import { RhinoImage, RhinoImageRatio } from './types';

type GetImageByRatioOptions = {
  imageHeight: number;
  imageType: number;
  imageRatio: RhinoImageRatio;
};

export function getImageByRatio(images: RhinoImage[], { imageHeight, imageType, imageRatio }: GetImageByRatioOptions) {
  const image = images.find((i) => i.type === imageType) ?? findImageByRatio(images, imageRatio);

  if (!image) {
    return;
  }

  const width = getWidthByHeight(imageHeight, imageRatio);

  return {
    height: imageHeight,
    width,
    url: calcImageUrl(image.url, imageHeight, width),
  };
}

function findImageByRatio(images: RhinoImage[], imageRatio: RhinoImageRatio) {
  // we scan in reversed order for backward compatibility
  for (let i = images.length - 1; i >= 0; i--) {
    if (images[i].ratio === imageRatio) {
      return images[i];
    }
  }
}
